<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="div_logo col-sm-6">
          <router-link class="lien_image" :to="{name:'Home'}">
            <img src="../assets/logo-neobus.jpg" width="250"/>
          </router-link>
          <a href="https://ccov.fr/" class="lien_image">
            <img class="center_horizonthal" alt="logo" src="../assets/logo_ccov.png" width="250px">
          </a>
        </div>
        <div class="col-sm-6 col_right">
          <p class="titre_footer">Contact</p>
          <div class="liens_footer">
            <ul>
              <li>
                <a class="telephone" href="mailto:contact@pretapartir.fr">contact@pretapartir.fr</a>
                <br>
                <a class="telephone" href="tel:0329941586">Neobus - 03 29 94 15 86</a>
                <br>
                <a class="telephone" href="tel:0329940877">CCOV   - 03 29 94 08 77</a>
                <br>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="copyright">
        <a href="/static/Règlement_intérieur_NEOBUS.pdf" target="_blank">Règlement intérieur</a>
        <p>Copyright © 2020 Sadap Neufchateau</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data () {
      return {}
    }
  }
</script>

<style scoped lang="scss">
  @import "../../node_modules/bootstrap/scss/bootstrap";
  @import "../sass/variables";

  .footer {
    color: $firstcolor;
    margin-top: 3rem;
    padding: 1rem;

    .titre_footer {
      color: $secondcolor;
      text-transform: uppercase;
      font-family: $titlefont;
      font-weight: 900;
      font-size: 25px;
    }

    .telephone {
      color: $secondcolor;
      font-size: 20px;
    }

    ul {
      padding: 0;
      list-style-type: none;
    }

    a {
      color: $secondcolor;
      font-weight: bold;
    }

    a:hover {
      color: $firstcolor;
      text-decoration: none;
    }

    .col_right {
      text-align: right;
      @include media-breakpoint-down(xs) {
        text-align: left;
        margin-top: 2rem;
      }
    }

    .liens_footer {
      display: grid;
    }

    .div_logo {
      @include media-breakpoint-down(xs) {
        display: flex;
        a {
          margin: auto;
        }
      }
    }

    .copyright {
      color: $annexecolor;
      display: block;
      justify-content: space-evenly;
      text-align: center;
      font-size: 15px;
      margin-top: 2rem;
    }

    .copyright a {
      color: $annexecolor;
      font-weight: normal;
    }

    .copyright a:hover {
      color: $firstcolor;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue